module.exports = __webpack_public_path__ + "img/239239481_1214580205713550_5844907077282762294_n.8a552eba.jpg";